export default [
	{
		path: '/class',
		component: () => import('pages/home/class/index'),
		name: 'HomeClass',
	},
];